var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"color":_vm.opaque ? 'grey' : _vm.color,"text-color":_vm.textColor}},on),[_c('v-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_c('span',[_vm._v(_vm._s(_vm.stat))])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.description))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }